import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'

export const Grid = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
`

export const Image = styled(ImageBase)`
    &:nth-child(1) {
        grid-row: 1 / 3;
        height: 316px;

        @media ${(props) => props.theme.query.min.tablet} {
            height: 471px;
        }
    }

    &:nth-child(2) {
        grid-column: 2 / 3;
    }

    &:nth-child(3) {
        grid-column: 2 / 3;
    }
`
